/* 🤖 this file was generated by svg-to-ts */
export const kzIconsTag: {
  name: 'tag';
  data: string;
} = {
  name: 'tag',
  data: `<svg viewBox="0 0 18.5 20.5"><path d="M9.4 20.5a2 2 0 0 1-1.12-.34L.92 15.33a2.06 2.06 0 0 1-.59-2.84l7-10.72a2 2 0 0 1 1.48-.9L14.62 0a2.06 2.06 0 0 1 2.28 1.5l1.53 5.7a2.06 2.06 0 0 1-.27 1.66l-7 10.72a2.06 2.06 0 0 1-1.76.92Zm5.52-19h-.08L9 2.35a.55.55 0 0 0-.38.24l-7 10.72a.55.55 0 0 0 .16.77l7.32 4.83a.55.55 0 0 0 .77-.16L16.91 8a.55.55 0 0 0 .09-.41l-1.55-5.68a.55.55 0 0 0-.53-.41Zm-6 .11Z" fill="currentColor"/><path d="M12.75 7.5a1.73 1.73 0 0 1-1-.29 1.75 1.75 0 0 1-.5-2.42 1.75 1.75 0 1 1 1.5 2.71Zm-.21-1.89a.25.25 0 1 0 .35-.07.25.25 0 0 0-.35.07Z" fill="currentColor"/></svg>`
};
